import { useTranslation } from 'react-i18next';
import { LoadingSpinner, type SpinnerSize } from '@/presentation/components/common/LoadingSpinner';

interface LoadingBlockProps {
  /** Texto bajo el spinner; default i18n `common.loading`. */
  label?: string;
  size?: SpinnerSize;
  /** Altura mínima del bloque (útil en tablas / cards vacías). */
  minHeightClassName?: string;
  className?: string;
  /** Oculta el texto y deja solo el spinner. */
  hideLabel?: boolean;
}

/**
 * Estado de carga de datos: spinner + label accesible.
 * Usar en tablas, reportes, paneles y recargas en general.
 */
export function LoadingBlock({
  label,
  size = 'md',
  minHeightClassName = 'min-h-[8rem]',
  className = '',
  hideLabel = false,
}: LoadingBlockProps) {
  const { t } = useTranslation();
  const text = label ?? t('common.loading');

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={`flex flex-col items-center justify-center gap-3 px-4 py-6 text-sm text-gray-500 dark:text-gray-400 ${minHeightClassName} ${className}`}
    >
      <LoadingSpinner size={size} />
      {!hideLabel && <span>{text}</span>}
      {hideLabel && <span className="sr-only">{text}</span>}
    </div>
  );
}
